
const LockIcon = ({
    color = '#000',
    fondo = '#fff',
    vetor_css = { fontSize: '50px' },
    main_css = { width: '40px', padding: '0px' }
}) => {

    return (
        <svg className="" xmlns="http://www.w3.org/2000/svg" style={main_css} viewBox="0 0 3500 5000">
            <g id="l4HwmZQm8zZBok0SoHefi4Y" fill={'url(#gradienteRojoAzul)'} >
                <g>
                    <path id="pZXl18EBb" d="M505 4790 c-196 -27 -354 -160 -427 -360 l-23 -65 0 -1070 0 -1070 26 -71 c79 -216 245 -340 480 -359 l86 -7 6 -176 c8 -216 21 -340 52 -497 93 -467 326 -767 685 -884 187 -61 468 -68 673 -16 366 93 610 369 728 823 41 158 58 305 66 544 l6 207 76 6 c234 19 401 144 480 359 l26 71 0 1070 0 1070 -23 65 c-61 169 -170 278 -336 339 l-71 26 -1225 1 c-674 1 -1252 -2 -1285 -6z m1625 -734 c0 -3 -36 -152 -80 -332 -44 -179 -80 -330 -80 -334 0 -3 25 -24 55 -45 64 -43 118 -113 148 -188 29 -73 29 -221 0 -294 -43 -109 -135 -199 -243 -239 -61 -23 -219 -23 -280 0 -108 40 -200 130 -243 239 -27 70 -29 210 -3 284 26 78 93 162 164 207 34 22 62 43 62 47 0 4 -29 149 -65 324 -36 174 -65 318 -65 320 0 3 114 6 253 8 138 1 280 3 315 5 34 1 62 0 62 -2z m306 -2458 c-14 -385 -54 -603 -144 -783 -49 -99 -170 -217 -272 -267 -98 -47 -165 -62 -275 -61 -167 0 -293 52 -406 164 -169 167 -259 512 -259 987 l0 152 682 0 681 0 -7 -192z">
                    </path>
                </g>
            </g>
        </svg>
    )
}

export default LockIcon;